import { Checkbox, DataHeader, DataSource, Layout, Panel, SearchPanel, Switch, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCompareHistoryList extends Layout {
    checkboxErrorsPresent: Checkbox;
    dataheaderCompareHistoryList: DataHeader;
    panelSearch: Panel;
    searchpanel2: SearchPanel;
    sourceEdiCompareHist: DataSource;
    switchNoChangesFound: Switch;
    tableCompareHistory: Table;
    textboxCompareDate: Textbox;
    textboxSourceRecordId: Textbox;
    textboxTargetMoveId: Textbox;
    textboxTargetOrderId: Textbox;
    textboxTransactionType: Textbox;
    textboxUserId: Textbox;
}
